
const feelField = "Comfort Feel";

export default {
  props: {
    options: { type: Array, default: () => [] },
    handle: { type: String, default: "" },
  },
  data: () => ({
    openTooltip: false,
  }),
  computed: {
    feels() {
      return (
        this.options
          .find(option => option.name === feelField)
          ?.optionValues.map(optionValue => optionValue.name) ?? []
      );
    },
    feelsLabel() {
      return this.feels.length
        ? `${this.feels.length} ${this.feels.length === 1 ? "feel" : "feels"}`
        : null;
    },
  },
};
